import { useContext, useMemo } from 'react';
import { FrameworkContext } from '../FrameworkContent';
import { ParentContext } from '../ParentContext';
import { useViewListData } from './useViewListData';
import _ from 'lodash'

export const useDataLinking = ({ dlps } = {}) => {

  const { parentCollection, parentCollectionKey, linkCollection } = dlps ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, eventInfo_state } = states
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const appDataDocuments = _.cloneDeep(eventInfo_state?.appDataDocuments)

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}

  const { view, viewKey, uivi } = fw_info ?? {}

  const _view = parentCollection || view
  const _uivi = linkCollection || uivi
  const _viewKey = parentCollectionKey || viewKey

  const aps_view = aps_views?.[_view]
  const viewItems = aps_view?.viewItems

  const viewItem_page = viewItems?.[_view]
  const viewItem_right = viewItems?.[_uivi]

  const data_page = useViewListData({ docName: _view, docKey: _viewKey })
  const data_right = useViewListData({ docName: _uivi })

  const keys_viewItems = useMemo(() => (viewItems ? Object.keys(viewItems) : []), [viewItems]);

  const docProps = useMemo(() => {
    const addList = []
    const addKeys = _.keys(appDataDocuments)
    const { props } = viewItem_page ?? {};

    if (props) {
      _.forEach(props, prop => {
        if (addKeys[prop]) {
          addList.push(prop);
        }
      })
    }

    _.forEach(keys_viewItems, vi => {
      if (!addList.includes(vi) && vi !== _view) {
        addList.push(vi);
      }
    })

    return _.sortBy(addList);

  }, [viewItem_page, appDataDocuments, keys_viewItems, _view]);

  const dataLinkProps = useMemo(() => ({
    parentCollection: _view,
    parentCollectionKey: _viewKey,
    linkCollection: _uivi,
  }), [_view, _viewKey, _uivi]);

  const x = useMemo(() => {
    return {
      data_page,
      data_right,
      view_page: _view,
      viewKey_page: _viewKey,
      view_right: _uivi,
      viewItem_page,
      viewItem_right,
      docProps,
      dataLinkProps
    }
  }, [_view, _viewKey, _uivi])

  return (
    x
  )
}
